import gql from "graphql-tag";

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    firstName
    lastName
    email
    emailVerificationTime
    phoneNumberVerificationTime
    phoneNumber
    referrer
    signupInstagramHandle
    connectedInstagramHandle
    instagramToken
    images
    homeCity {
       geonamesId
       name
    }
    locations
    status
    skills
    registeredDate
    membership
  }
`;

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    currentUser {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_INFO = gql`
  mutation updateUserInfo($input: UserInfoInput) {
    updateUserInfo(input: $input) {
      ...UserFragment
      auth {
        token
      }
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_SKILLS = gql`
  mutation updateUserSkills($input: UserSkillsInput) {
    updateUserSkills(input: $input) {
      ...UserFragment
      auth {
        token
      }
    }
  }
  ${USER_FRAGMENT}
`;


export const SEND_NEW_EMAIL_VERIFY_CODE = gql`
  mutation sendNewEmailVerifyCode($recaptchaToken: String, $newEmail: String) {
    sendNewEmailVerifyCode(recaptchaToken: $recaptchaToken, newEmail: $newEmail) {
      id
    }
  }
`;

export const CHECK_NEW_EMAIL_VERIFY_CODE = gql`
  mutation checkNewEmailVerifyCode($code: String, $recaptchaToken: String) {
    checkNewEmailVerifyCode(code: $code, recaptchaToken: $recaptchaToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const SEND_NEW_PHONE_NUMBER_VERIFY_CODE = gql`
  mutation sendNewPhoneNumberVerifyCode($recaptchaToken: String, $newPhoneNumber: String) {
    sendNewPhoneNumberVerifyCode(recaptchaToken: $recaptchaToken, newPhoneNumber: $newPhoneNumber) {
      id
    }
  }
`;

export const CHECK_NEW_PHONE_NUMBER_VERIFY_CODE = gql`
  mutation checkNewPhoneNumberVerifyCode($code: String, $recaptchaToken: String) {
    checkNewPhoneNumberVerifyCode(code: $code, recaptchaToken: $recaptchaToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const GET_USER_IMAGES = gql`
  mutation getUserImages {
    getUserImages
  }
`;

export const EXCHANGE_TOKEN = gql`
  mutation exchangeToken($code: String, $redirectUri: String) {
    exchangeToken(code: $code, redirectUri: $redirectUri)
  }
`;

export const INSTAGRAM_THUMBNAIL_URL = gql`
  mutation instagramThumbnailUrl(
    $instagramMediaPermalink: String
    $large: Boolean
  ) {
    instagramThumbnailUrl(instagramMediaPermalink: $instagramMediaPermalink, large: $large)
  }
`;


export const UPDATE_USER_PHOTOS = gql`
    mutation updateUserPhotos($input: UserPhotosInput) {
        updateUserPhotos(input: $input) {
            ...UserFragment
        }
    }
    ${USER_FRAGMENT}
`;
